import { useQuery } from "@tanstack/react-query";
import { Organization } from "../api";
import { organizationQueries } from "../api/organization.queries";

interface UseOrganizationProps {
  enabled?: boolean;
}

export function useOrganization({ enabled = true }: UseOrganizationProps = {}) {
  const query = useQuery({
    ...organizationQueries.getOrganization(),
    enabled,
  });

  return {
    ...query,
    data: query.data as Organization,
  };
} 